module.exports = __webpack_public_path__ + "img/boston-top-dentist.489cf8a7.png";